import classNames from "classnames";
import { ListTemplate } from "../Templates";
import styles from "./List.module.scss";
import React from "react";
function List({ itemSize = "md", listStyle = "main", classNameContainer, ...props }) {
    return (React.createElement(ListTemplate, { classNameContainer: classNames(styles.list, styles[itemSize], styles[listStyle], classNameContainer), ...props }));
}
export default List;
